<div class="calsoft-vertical-navigation-wrapper">

  <!-- Header -->
  <div class="calsoft-vertical-navigation-header">
    <ng-content select="[calsoftVerticalNavigationHeader]"></ng-content>
  </div>

  <!-- Content -->
  <div class="calsoft-vertical-navigation-content" calsoftScrollbar
    [calsoftScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}" #navigationContent>

    <!-- Content header -->
    <div class="calsoft-vertical-navigation-content-header">
      <ng-content select="[calsoftVerticalNavigationContentHeader]"></ng-content>
    </div>

    <!-- Items -->
    <ng-container class="other-items" *ngFor="let item of navigation let i=index; trackBy: trackByFn">

      <!-- Skip the hidden items -->
      <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

        <!-- Aside -->
        <calsoft-vertical-navigation-aside-item *ngIf="item.type === 'aside'" [item]="item" [name]="name"
          [activeItemId]="activeAsideItemId" [autoCollapse]="autoCollapse" [skipChildren]="true"
          (click)="toggleAside(item)"></calsoft-vertical-navigation-aside-item>

        <!-- Basic -->
        <calsoft-vertical-navigation-basic-item *ngIf="item.type === 'basic'" [item]="item"
          [name]="name"></calsoft-vertical-navigation-basic-item>

        <!-- Collapsable -->
        <calsoft-vertical-navigation-collapsable-item *ngIf="item.type === 'collapsable'" [item]="item" [name]="name"
          [autoCollapse]="autoCollapse"></calsoft-vertical-navigation-collapsable-item>

        <!-- Divider -->
        <calsoft-vertical-navigation-divider-item *ngIf="item.type === 'divider'" [item]="item"
          [name]="name"></calsoft-vertical-navigation-divider-item>

        <!-- Group -->
        <calsoft-vertical-navigation-group-item *ngIf="item.type === 'group'" [item]="item" [name]="name"
          [autoCollapse]="autoCollapse"></calsoft-vertical-navigation-group-item>

        <!-- Spacer -->
        <calsoft-vertical-navigation-spacer-item *ngIf="item.type === 'spacer'" [item]="item"
          [name]="name"></calsoft-vertical-navigation-spacer-item>



        <div *ngIf="navigation.length === i+1">

          <div class="sideBarMobile">

          </div>

        </div>

      </ng-container>



    </ng-container>

    <!-- Content footer -->
    <div class="calsoft-vertical-navigation-content-footer">
      <ng-content select="[calsoftVerticalNavigationContentFooter]"></ng-content>
    </div>

  </div>

  <!-- <div class="user-profile-container" [matMenuTriggerFor]="userMenu">
      <div class="avatar-wrapper">
        <img class="user-avatar" [src]="user.avatar" [alt]="user.name">
        <div class="status-indicator" [ngClass]="user.status"></div>
      </div>
     
      <mat-icon class="chevron-icon">expand_more</mat-icon>
    </div> -->

  <!-- Footer -->
  <div class="calsoft-vertical-navigation-footer">
    <ng-content select="[calsoftVerticalNavigationFooter]"></ng-content>
  </div>

</div>

<!-- Aside -->
<div class="calsoft-vertical-navigation-aside-wrapper" *ngIf="activeAsideItemId" calsoftScrollbar
  [calsoftScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}" [@fadeInLeft]="position === 'left'"
  [@fadeInRight]="position === 'right'" [@fadeOutLeft]="position === 'left'" [@fadeOutRight]="position === 'right'">

  <!-- Items -->
  <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

    <!-- Skip the hidden items -->
    <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

      <!-- Aside -->
      <calsoft-vertical-navigation-aside-item *ngIf="item.type === 'aside' && item.id === activeAsideItemId"
        [item]="item" [name]="name" [autoCollapse]="autoCollapse"></calsoft-vertical-navigation-aside-item>

    </ng-container>

  </ng-container>

</div>

<mat-menu #plusMenu="matMenu" class="plus-menu-panel">
  <div class="plus-menu-content">
    <div class="plus-section">
      <div class="plus-section-header">QUICK ADD</div>
      <div class="plus-grid">
        <div class="plus-grid-item" (click)="addContact()">
          <div class="icon-circle">
            <mat-icon [svgIcon]="'heroicons:user-add'"></mat-icon>
          </div>
          <div class="item-label">Add Contact</div>
        </div>
        <div class="plus-grid-item" (click)="addAccount()">
          <div class="icon-circle">
            <mat-icon [svgIcon]="'heroicons:office-building'"></mat-icon>
          </div>
          <div class="item-label">Add Account</div>
        </div>
        <div class="plus-grid-item" (click)="addDeals()">
          <div class="icon-circle">
            <mat-icon [svgIcon]="'heroicons:currency-dollar'"></mat-icon>
          </div>
          <div class="item-label">Add Deal</div>
        </div>
        <!-- <div class="plus-grid-item" (click)="explore()">
          <div class="icon-circle">
            <mat-icon [svgIcon]="'heroicons:sparkles'"></mat-icon>
          </div>
          <div class="item-label">Marketplace</div>
        </div> -->
      </div>
    </div>
  </div>
</mat-menu>

<!-- User Menu (copied from header-user to provide profile actions in vertical nav) -->
<mat-menu #userMenu="matMenu" class="modern-menu">
  <button mat-menu-item (click)="profile()">
    <mat-icon [svgIcon]="'heroicons:user-circle'"></mat-icon>
    <span>My Profile</span>
  </button>
  <button mat-menu-item (click)="billing()">
    <mat-icon [svgIcon]="'heroicons:credit-card'"></mat-icon>
    <span>Billing & Subscription</span>
  </button>
  <button mat-menu-item (click)="openTwoFactorAuth()">
    <mat-icon [svgIcon]="'heroicons:shield-check'"></mat-icon>
    <span>Enable Authentication</span>
  </button>

  <button mat-menu-item (click)="startTour()">
    <mat-icon [svgIcon]="'heroicons:flag'"></mat-icon>
    <span>Tour</span>
  </button>

  <mat-divider></mat-divider>
  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons:logout'"></mat-icon>
    <span>Sign out</span>
  </button>
</mat-menu>